import React, { useState, useEffect } from 'react';
import { Star } from 'lucide-react';
import PricingModal from '../components/modals/PricingModal'
import '../styles/Dashboard.css';
import { API_URL } from '../app/constants'

const StreakUpgradeButton = ({ source = 'Unknown Page' }) => {
  const [userStreak, setUserStreak] = useState(0);
  const [userStatus, setUserStatus] = useState(null);
  const [isUserLoaded, setIsUserLoaded] = useState(false);
  const [showPremiumModal, setShowPremiumModal] = useState(false);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const jwt = localStorage.getItem('jwt');
        const response = await fetch(`${API_URL}/api/v1/auth/me`, {
          headers: { 'Authorization': `Bearer ${jwt}` },
          method: "GET",
        });
        
        if (response.ok) {
          const userData = await response.json();
          setUserStatus(userData.status);
          setUserStreak(userData.streak?.streak_count || 0);
          // Petit délai pour une transition plus naturelle
          setTimeout(() => {
            setIsUserLoaded(true);
          }, 100);
        }
      } catch (error) {
        console.error('Error fetching user data:', error);
        setIsUserLoaded(true);
      }
    };

    fetchUserData();
  }, []);

  const handleUpgradeClick = () => {
    if (userStatus !== 'active') {
      setShowPremiumModal(true);
    }
  };

  return (
    <>
      <div className="streak-upgrade-container">
        <span className="streak-number" style={!isUserLoaded ? {opacity: 0.3} : {}}>
          {isUserLoaded ? userStreak : '•'}
        </span>
        <span className="streak-emoji">🌸</span>
        <button 
          className="upgrade-button" 
          onClick={handleUpgradeClick}
          style={userStatus === 'active' ? {cursor: 'default', opacity: 0.8} : {}}
        >
          <Star size={12} className="upgrade-star" />
          <span className="upgrade-text">{userStatus === 'active' ? 'Premium' : 'Upgrade'}</span>
        </button>
      </div>

      <PricingModal 
        isOpen={showPremiumModal}
        onClose={() => setShowPremiumModal(false)}
        source={source}
      />
    </>
  );
};

export default StreakUpgradeButton;